export default {
  locale: "en",
  language: {
    name: "En",
    Language: "Language",
  },
  navbar: {},
  summary: {
    tonext: "blocks until next round",
    totaltext1: "Nodes",
    totaltext2: "in Total",
    totaltext: "Nodes in Total",
    consensustext1: "Consensus",
    consensustext2: "Nodes",
    consensustext: "Consensus Nodes",
    candidatetext1: "Candidate",
    candidatetext2: "Nodes",
    candidatetext: "Candidate Nodes",
    synchronoustext1: "Synchronous",
    synchronoustext2: "Nodes",
    synchronoustext: "Synchronous Nodes",
    totalstake: "Total Stake Amount",
    oftotal: "of Total ONT Circulating Supply",
    increse: "Rank Increase ",
    increseexplain: "(Rank Since Last Round)",
    applynow: "How to Sign Up to Run an Ontology Node",
    calculator: "Node & Staking Yield Calculator",
    launchapp: "Launch App",
  },
  nodelist: {
    cnode: "Consensus Nodes",
    nnode: "Candidate Nodes",
    checkmark: "Checkmark",
    long: "Long term",
    verified: "Verified contact information",
    stable: "Stable fee sharing ratio",
    harbinger: "Ontology Harbinger",
    badActor: "Bad Actor",
    risky: "Alert",
    checkdesc: "View details of node checkmark:",
    rank: "#",
    rankDesc: "Rank Since Last Round",
    verification: "Verified node",
    name: "Name",
    top49: "Status",
    top49Desc:
      "Nodes whose status stays as 'Top 49' by the end of the current round will receive the Foundation Bonus ONG reward in the next round.",
    location: "Location",
    lastblocks: "Latest Block",
    blockproduced: "Block Produced",
    income: "Fee Income in Last Round (ONG)",
    fee: "Fee Sharing Ratio",
    progress: "Reached Stake Cap",
    stake: "Action",
    stakeurl:
      "https://medium.com/ontologynetwork/owallet-stake-authorization-feature-released-11776706bb34",
    initpos: "Node Stake",
    totalstake: "Total Stake",
    reward1:
      "This is the percentage of the transactions fees and released ONG yield of the total amount of stake yield for node’s own initial stake and the total user’s stake, that the node has chosen to share with their stakers in the next consensus round.",
    annual: "Annualized Yield",
    annual1:
      "This estimated data is calculated according to the the real-time network operation, staking status and ONT/ONG price",
    notopen: "Unavailable",
    gccurl:
      "https://medium.com/ontologynetwork/ontology-gcc-global-community-contributor-program-is-coming-e4be768f17e3",
  },
  cobuild: {
    title: "Co-build Node",
  },
  detail: {
    title: "Node Detail",
    name: "Name",
    position: "Location",
    address: "Address",
    website: "Website",
    social: "Social Network",
    pk: "Public Key",
    ontid: "ONT ID",
    transactions: "Transactions",
    transfers: "Transfers",
    stakeamount: "Node Stake",
    userstake: "User Stake",
    description: "Description",
    rank: "Rank",
    stakeNow: "Stake Now",
  },
  tab: {
    balance: "BALANCE",
    transactions: "TRANSACTIONS",
    voter: "DELEGATORS",
    transfer: "TRANSFERS",
    balanceValue: "balance",
    transactionsValue: "transactions",
    voterValue: "voter",
    transferValue: "transfer",
  },
  back: {
    back: "Back",
  },
  balance: {
    name: "TOKEN",
    type: "TYPE",
    balance: "BALANCE",
  },
  voter: {
    address: "ADDRESS",
    vote: "USER STAKE",
    percent: "PERCENTAGE",
  },
  tx: {
    hash: "HASH",
    status: "STATUS",
    block: "BLOCK",
    time: "TIME",
    fee: "FEE",
    result: "RESULT",
    from: "FROM",
    to: "TO",
    amount: "AMOUNT",
    token: "TOKEN",
    way: "",
  },
  stake: {
    progress: "Staking Progress",
    round1: "(Round",
    round2: ")",
    days: "days",
    hours: "hours",
    left: "left",
    currnetround1: "in current round (estimate)",
    currnetround: "in current round",
    blocks: "blocks",
    guide: "Stake Guide",
    onto: "ONTO",
    owallet: "OWallet",
    historyround: "Round",
    startheight: "Start Height",
    endheight: "End Height",
    starttime: "Start Time",
    endtime: "End Time",
    processing: "Processing",
  },
  onto: {
    url: "https://ontology-1.gitbook.io/ontology-node-staking-docs/guides/ontology-node-staking-on-onto",
    guideText: "Node Staking on ONTO",
    item1: "Step 1: ",
    item2: "Download ",
    item3: "ONTO",
    item4: "https://app.ont.io/socialmedia/pic/enimage019.png",
    item5: "Step 2: ",
    item6: "Open ONTO, click the",
    item7: "“Assets”",
    item8: " tab and then click ",
    item9: "“ONT”.",
    item10: "",
    item11: "https://app.ont.io/socialmedia/pic/enimage021.png",
    item12: "Step 3: ",
    item13: "Click the ",
    item14: "“Stake”",
    item15: " button on the bottom left corner to enter the staking page.",
    item16: "https://app.ont.io/socialmedia/pic/enimage023.png",
    item17: "Step 4: ",
    item18: "Click ",
    item19: "“Recommended stake nodes”",
    item20:
      " and select the node you would like to stake into and enter the stake amount (an integral multiple of 1).",
    item21: "Please note: ",
    item22:
      "If you would like stake just 1 ONT, please enter “1” and click the ",
    item23: "“Stake now”",
    item24:
      " button. Enter your password to confirm the authorized stake is complete.",
    item25: "https://app.ont.io/socialmedia/pic/enimage025.png",
    item26: "https://app.ont.io/socialmedia/pic/enimage027.png",
    item27: "Step 5: ",
    item28:
      "After the stake authorization complete, you can check your stake details under ",
    item29: "“My stake”",
    item30: " tab. ",
    item31: "https://app.ont.io/socialmedia/pic/enimage029.png",
    item32: "Click the ",
    item33: "“Claim”",
    item34: " button on the bottom left to withdraw ONG.",
    item35: "",
    item36: "",
    item37: "https://app.ont.io/socialmedia/pic/enimage031.jpg",
    item38: "How to cancel your stake?",
    item39: "Click the ",
    item40: "“Cancel stake”",
    item41: " button under ",
    item42: "“My stake”",
    item43: " page. Before you cancel your stake, please click the ",
    item44: "“Info”",
    item45:
      " on the top right corner and read the rules carefully. You can click the ",
    item46: "",
    item47: "",
    item48: "“Withdraw”",
    item49: " button to withdraw your ONT.",
    item50: "https://app.ont.io/socialmedia/pic/enimage033.png",
    ontoappurl: "https://onto.app/",
  },
  owallet: {
    url: "https://ontology-1.gitbook.io/ontology-node-staking-docs/guides/ontology-node-staking-on-owallet",
    guideText: "Node Staking on OWallet",
    item1: "Step 1: ",
    item2: "Download ",
    item3: "OWallet",
    item4: " (Windows/macOS/Linux)",
    item5: "https://app.ont.io/socialmedia/pic/enimage001.png",
    item6: "Step 2: ",
    item7: "Open your OWallet and click the ",
    item8: "“Stake Authorization”",
    item9: "https://app.ont.io/socialmedia/pic/enimage003.png",
    item10: "Step 3: ",
    item11:
      " View the node list. After selecting a node, click on the arrow, select the wallet where your ONT is, and enter the node stake authorization page.",
    item12: "Note: ",
    item13: "You can click ",
    item14: "“My Stake”",
    item15:
      " button in the upper right corner to see authorized stakes you have already made.",
    item16: "https://app.ont.io/socialmedia/pic/enimage005.png",
    item17: "Tips: ",
    item18:
      "Of course, try to choose the node with the highest reward proportion!",
    item19: "OWallet also supports Ledger wallet to complete authorized stake.",
    item20: "https://app.ont.io/socialmedia/pic/enimage007.png",
    item21: "Step 4: ",
    item22: "Click the ",
    item23: "“Submit new stake authorization”",
    item24:
      " button and select the number of ONT units you would like to authorize for stake (1 ONT per unit). Enter your password to confirm the authorized stake is complete.",
    item25: "https://app.ont.io/socialmedia/pic/enimage009.png",
    item26: "https://app.ont.io/socialmedia/pic/enimage011.png",
    item27: "How to cancel your stake?",
    item28: "Click the ",
    item29: "“Cancel stake authorization”",
    item30: " button and enter the amount of stake you would like to cancel.",
    item31: "https://app.ont.io/socialmedia/pic/enimage013.png",
    item32: "https://app.ont.io/socialmedia/pic/enimage015.png",
    item33: "How to redeem the staking rewards?",
    item34: "Click the “Redeem” button to withdraw your staking rewards.",
    item35: "",
    item36: "https://app.ont.io/socialmedia/pic/enimage017.png",
    owalleturl: "https://github.com/ontio/OWallet/releases",
  },
  calculator: {
    title: "Node & Staking Yield Calculator",
    node: "Node",
    user: "Staker",
    choosenodetype: "Please select the node type you want to operate",
    choosenodetypeuser: "Please select the node you want to stake into",
    typemsg:
      "For more details of the yield calculation methods for consensus node and candidate node, please refer to the",
    doc: "Ontology Staking Incentive Calculation whitepaper",
    url: "https://node.ont.io/Ontology%20Staking%20Incentive%20Calculation_202109.pdf",
    cnode: "Consensus node",
    nnode: "Candidate node",
    stakeamount: "Intended stake amount (ONT)",
    stakeamountuser: "Please select the node you want to stake into",
    amountMsg1: "Minimum stake required to become a consensus node: ",
    amountMsg2: "Minimum stake required to become a candidate node: ",
    amountMsg3: "Maximum stake required to become a candidate node: ",
    reward: "Node fee sharing ratio (% for node itself)",
    result: "Result",
    totalincome: "Total yield:",
    totalrate: "Expected yield rate:",
    totalong: "Expected total ONG yield:",
    detail: "Details",
    feerate: "Expected fee yield rate:",
    feeong: "Expected fee yield (ONG):",
    releaserate: "Expected released ONG yield rate:",
    releaseong: "Expected released ONG:",
    foundationrate: "Expected Ontology Foundation Bonus yield rate:",
    foundationong: "Expected Ontology Foundation Bonus (ONG):",
    choosenode: "Select a node",
    maxstakeMsg: "Maximum stake amount for this node: ",
    nodeChangeMsg:
      "Your stake will make the node a consensus node in the next round, and the yield will change. For specific calculation rules, please refer to",
    calc: "Calculate",
    disclaimtitle: "Disclaimer:",
    disclaimq: "How accurate is this calculation?",
    disclaima:
      "The effective yield depends on many dynamic variables, such as the ONT & ONG prices, total staked amount on the network, and total ONT staked on each node. The presented results are based on our own prediction formulas, and we do not guarantee any specific accuracy. The result is only a rough estimate and should not be used as financial advice.",
  },
  footer: {
    flag: "en",
    Development: "Development",
    DeveloperCenter: "Developer Center",
    dApp: "dApps List",
    Tutorials: "Tutorials",
    Documentation: "Documentation",
    Bounty: "Bounty",
    SmartX: "SmartX",
    Github: "Github",
    Cooperation: "Cooperation",
    CooperateWithOntology: "Cooperate with Ontology",
    TrustEcosystem: "Trust Ecosystem",
    Nodes: "Nodes",
    About: "About",
    Press: "Press",
    TechNews: "Tech News",
    Team: "Team",
    AboutOntology: "About Ontology",
    WhitePaper: "White Paper",
    Explorer: "Explorer",
    dApps: "dApps",
    dAppsList: "dApps List",
    SubmitAdApp: "Submit a dApp",
    node: "Node",

    aboutUs: "About Us",
    joinUs: "Join Us",
    Branding: "Branding",
    Partners: "Partners",
    ContactUs: "Contact Us",
    useOntology: "Use Ontology",
    OntOng: "ONT & ONG",
    Bridge: "Bridge",
    NodesStaking: "Nods & Staking",
    OWallet: "OWallet",
    ONTO: "ONTO Wallet",
    Developers: "Developers",
    GetTestnetTokens: "Get TestNet Tokens",
    StakeOnt: "Stake ONT",
    stONT: "stONT",
    Docs: "Docs",
    Calculator: "Calculator",
    RunANode: "Run A Node",
    Discord: "Discord",
    CommunityForm: "Community Forum",
  },
};
